import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  country: 'Colombia'
}, {
  name: 'Juan',
  country: 'México'
}, {
  name: 'Carlos',
  country: 'España'
}, {
  name: 'Ana',
  country: 'Argentina'
}, {
  name: 'Luis',
  country: 'Chile'
}, {
  name: 'Sofía',
  country: 'Perú'
}, {
  name: 'Diego',
  country: 'Estados Unidos'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isClosed, setIsClosed] = useState(false);
  useEffect(() => {
    if (isClosed) return;
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setIsVisible(true);
      }, 1000);
    }, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, [isClosed]);
  if (isClosed) return null;
  const currentPurchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-182">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 pr-10 flex items-center gap-4 max-w-sm relative" data-id="element-183">
        <button onClick={() => setIsClosed(true)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-184">
          <XIcon className="w-4 h-4" data-id="element-185" />
        </button>
        <div className="bg-[#7a9e7a]/15 p-2 rounded-full flex-shrink-0" data-id="element-186">
          <CheckCircleIcon className="w-6 h-6 text-[#7a9e7a]" data-id="element-187" />
        </div>
        <div data-id="element-188">
          <p className="text-sm font-opensans text-gray-800" data-id="element-189">
            <span className="font-bold" data-id="element-190">{currentPurchase.name}</span> de{' '}
            {currentPurchase.country}
          </p>
          <p className="text-xs text-gray-500 font-opensans mt-1" data-id="element-191">
            Acaba de comprar el Mega Pack
          </p>
          <p className="text-[10px] text-[#c0703a] font-bold mt-1" data-id="element-192">
            Hace unos minutos
          </p>
        </div>
      </div>
    </div>;
}